module.exports = __webpack_public_path__ + "static/media/BuilderIcon.2bdadf48.svg";